import { useState } from "react";
import { Box, Typography, Paper, Button, Grid } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";

// ✅ Reusing same styled card
const AreaCard = styled(Paper)(({ theme, selected }) => ({
  padding: theme.spacing(2),
  borderRadius: "16px",
  backgroundColor: selected ? alpha("#30B0C7", 0.2) : alpha("#FFFFFF", 0.9),
  backdropFilter: "blur(8px)",
  boxShadow:
    "0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)",
  cursor: "pointer",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  minHeight: "90px",

  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
  },

  ...(selected && {
    border: "2px solid #30B0C7",
  }),
}));

const StepTwo = ({ onNext, onBack }) => {
  const areas = [
    { label: "Urban", tier: 1 },
    { label: "Suburban", tier: 2 },
    { label: "Rural", tier: 3 },
  ];

  const [selectedTier, setSelectedTier] = useState(null);

  const handleSelect = (tier) => {
    setSelectedTier(tier);
  };

  const handleNextClick = () => {
    if (selectedTier) onNext({ areaType: selectedTier });
  };

  return (
    <Box>
      <Typography
        sx={{ textAlign: "center", fontFamily: "Aclonica", py: 2 }}
        variant="h4"
        fontWeight={600}
        mb={3}
      >
        Select Your Area Type
      </Typography>

      {/* ✅ Grid Layout */}
      <Grid container spacing={2} justifyContent="center">
        {areas.map(({ label, tier }) => (
          <Grid item xs={12} sm={6} md={4} key={label}>
            <AreaCard
              selected={selectedTier === tier}
              onClick={() => handleSelect(tier)}
            >
              <Typography fontSize="1.1rem" fontWeight={500}>
                {label}
              </Typography>
            </AreaCard>
          </Grid>
        ))}
      </Grid>

      {/* ✅ Buttons */}
      <Box mt={4} display="flex" justifyContent="center" gap={2}>
        <Button
          variant="outlined"
          onClick={onBack}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "100px",
            textTransform: "none",
            fontWeight: 600,
            width: "200px",
            p: 1,
            fontSize: "18px",
          }}
        >
          Back
        </Button>

        <Button
          variant="contained"
          disabled={!selectedTier}
          onClick={handleNextClick}
          sx={{
            backgroundColor: "#30B0C7",
            borderRadius: "100px",
            textTransform: "none",
            fontWeight: 600,
            "&:hover": { backgroundColor: "#2799AD" },
            width: "200px",
            p: 1,
            fontSize: "18px",
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default StepTwo;
